module.exports = __webpack_public_path__ + "img/room.a135efc0.svg";